// ----------------------------------------------------------------------
// <copyright file="Izenda.PropertiesBuilderConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';
import Uiconstants from 'logic/data/Izenda.UIConstants';

// define CUSTOM_URL
const CUSTOM_URL = {
  NAME: 'customURL',
  get CONTENT_DESCRIPTION() {
    return localizer.getText('PROPERTIES_BUILDER_CONSTANTS_CUSTOM_URL_CONTENT_DESCRIPTION');
  },
  CONSTRAINTS: {
    URL: {
      presence: {
        presence: true,
        get message() {
          return localizer.getText('PROPERTIES_BUILDER_CONSTANTS_CUSTOM_URL_CONSTRAINTS_MESSAGE_URL_IS_REQUIRED');
        }
      }
    }
  },
  DEFAULT_VALUE: 'LINK_NEW_WINDOW',
  OPTIONS: {
    LINK_NEW_WINDOW: 'LINK_NEW_WINDOW',
    LINK_NEW_TAB: 'LINK_NEW_TAB',
    LINK_CURRENT_WINDOW: 'LINK_CURRENT_WINDOW'
  }
};
// define EMBEDDED_JAVASCRIPT
const EMBEDDED_JAVASCRIPT = {
  NAME: 'embeddedJavascript',
  get CONTENT_DESCRIPTION() {
    return localizer.getText('PROPERTIES_BUILDER_CONSTANTS_EMBEDDED_JAVASCRIPT_CONTENT_DESCRIPTION');
  },
  CONSTRAINTS: {
    SCRIPT: {
      presence: {
        presence: true,
        get message() {
          return localizer.getText('PROPERTIES_BUILDER_CONSTANTS_EMBEDDED_JAVASCRIPT_MESSAGE_JAVASCRIPT_IS_REQUIRED');
        }
      }
    }
  }
};
// define SUB_REPORT
const SUB_REPORT = {
  NAME: 'subReport',
  get SUBREPORT_FILTER_TEXT() {
    return localizer.getText('PROPERTIES_BUILDER_CONSTANTS_SUB_REPORT_SUBREPORT_FILTER_TEXT');
  },
  TABLE_DEF: {
    fieldInCurrentReport: {
      key: 'fieldInCurrentReport',
      width: 240,
      get title() {
        return localizer.getText('PROPERTIES_BUILDER_CONSTANTS_SUB_REPORT_TABLE_DEF_FIELD_IN_CURRENT_REPORT');
      },
      sortable: false
    },
    fieldInSubReport: {
      key: 'fieldInSubReport',
      width: 240,
      get title() {
        return localizer.getText('PROPERTIES_BUILDER_CONSTANTS_SUB_REPORT_TABLE_DEF_FIELD_IN_SUB_REPORT');
      },
      sortable: false
    },
    deleteField: { key: 'deleteField', width: 20, sortable: false }
  },
  ERROR_MESSAGE: {
    get MULTIPLE_VALUE() {
      return localizer.getText('PROPERTIES_BUILDER_CONSTANTS_SUB_REPORT_ERRORS_MULTIPLE_VALUE');
    },
    get CANT_RESOLVE_FIELD() {
      return localizer.getText('PROPERTIES_BUILDER_CONSTANTS_SUB_REPORT_ERRORS_CANT_RESOLVE_FIELD');
    },
    get NEED_UPDATE_RESULT() {
      return localizer.getText('PROPERTIES_BUILDER_CONSTANTS_SUB_REPORT_ERRORS_NEED_UPDATE_RESOLVE');
    }
  },
  CONSTRAINTS: {
    REPORTS_CONSTRAINTS: {
      presence: {
        presence: true,
        get message() {
          return localizer.getText('PROPERTIES_BUILDER_CONSTANTS_SUB_REPORT_CONSTRAINTS_REPORTS_IS_REQUIRED');
        }
      }
    },
    STYLE_CONSTRAINTS: {
      presence: {
        presence: true,
        get message() {
          return localizer.getText('PROPERTIES_BUILDER_CONSTANTS_SUB_REPORT_CONSTRAINTS_STYLE_IS_REQUIRED');
        }
      }
    },
    REPORT_PART_USED_CONSTRAINTS: {
      presence: {
        presence: true,
        get message() {
          return localizer.getText('PROPERTIES_BUILDER_CONSTANTS_SUB_REPORT_CONSTRAINTS_REPORT_PART_USED_IS_REQUIRED');
        }
      }
    },
    REQUIRED_CONSTRAINT: {
      presence: {
        presence: true,
        get message() {
          return localizer.getText('COMMON_CONSTRAINT_REQUIRED');
        }
      }
    }
  },
  ICON_TYPES: [
    { value: 'iconLink01', icon: 'icon-link-01' },
    { value: 'iconLink02', icon: 'icon-link-02' },
    { value: 'iconLink03', icon: 'icon-link-03' },
    { value: 'iconLink04', icon: 'icon-link-04' },
    { value: 'iconLink05', icon: 'icon-link-05' },
    { value: 'iconLink06', icon: 'icon-link-06' },
    { value: 'iconLink07', icon: 'icon-link-07' }
  ],
  DEFAULT_ICON: { value: 'iconLink01', icon: 'icon-link-01' },
  get UNCATEGORIZED() {
    return localizer.getText('COMMON_LABEL_UNCATEGORIZED');
  },
  UNDEFINED: '00000000-0000-0000-0000-000000000000',
  ALL_OPTION: {
    get title() {
      return localizer.getText('COMMON_LABEL_ALL');
    },
    id: 'All'
  },
  SUB_REPORT_GRID: {
    get DUPLICATE_ERROR_MESSAGE() {
      return localizer.getText('PROPERTIES_BUILDER_CONSTANTS_SUB_REPORT_DUPLICATE_MAPPING');
    },
    VALIDATOR_GROUP: 'Subreport'
  }
};
// define MESSAGE
const MESSAGE = {
  get COLUMN_GROUP_TOOLTIP() {
    return localizer.getText('PROPERTIES_BUILDER_CONSTANTS_MESSAGE_COLUMN_GROUP_TOOLTIP');
  },
  get DUPLICATE_VIEW_SETTING() {
    return localizer.getText('PROPERTIES_BUILDER_CONSTANTS_MESSAGE_DUPLICATE_VIEW_SETTING');
  },
  get EMBEDDED_LINK_SUB_REPORT() {
    return localizer.getText('PROPERTIES_BUILDER_CONSTANTS_MESSAGE_EMBEDDED_LINK_SUB_REPORT');
  }
};
// define DEFAULT_PROPERTIES_VALUE
const DEFAULT_PROPERTIES_VALUE = {
  dataFormattings: {
    color: {
      textColor: {},
      defaultRangeObject: {
        rangePercent: null,
        rangeValue: null,
        value: null,
        allValues: null
      },
      cellColor: {}
    },
    alternativeText: {
      rangePercent: null,
      rangeValue: null,
      value: null
    },
    customURL: {
      url: '',
      get option() {
        return CUSTOM_URL.DEFAULT_VALUE;
      }
    },
    embeddedJavascript: {
      script: ''
    },
    subTotal: {
      label: '',
      function: '',
      expression: '',
      dataType: '',
      previewResult: '',
      levels: []
    },
    grandTotal: {
      label: '',
      function: '',
      expression: '',
      dataType: '',
      previewResult: '',
      format: {}
    }
  },
  drillDown: {
    subReport: {
      selectedReport: null,
      style: null,
      reportPartUsed: null,
      reportFilter: true,
      mappingFields: [],
      selectedIconValue: null,
      viewSettingByLink: null
    }
  }
};

/**
 * @constant BORDER_POSITION
 * @description positioning constants for BorderSetting component
 */
const BORDER_POSITION = {
  ALL: 'all',
  INLINE: 'inline',
  MID_VER: 'midVer',
  MID_HOR: 'midHor',
  OUTLINE: 'outline',
  NONE: 'none'
};



export default {
  BORDER_POSITION,
  // report-part > field properties > custom url
  CUSTOM_URL,
  // report-part > field properties > embedded script
  EMBEDDED_JAVASCRIPT,
  // report-part > field properties > sub report
  SUB_REPORT,
  MESSAGE,
  CHECK_UNIQ_OPTIONS: [CUSTOM_URL.NAME, EMBEDDED_JAVASCRIPT.NAME, SUB_REPORT.NAME],
  DEFAULT_PROPERTIES_VALUE
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.PropertiesBuilderConstants.js